import { useState } from "react";
import toast from "react-hot-toast";
import { Fade } from "react-awesome-reveal";
import { BiCheck } from "react-icons/bi";
import { IoClose } from "react-icons/io5";
import { checkDisscount } from "../../../../services/proAnalyse";

const AnalyseType = ({
  submitTestHandler,
  loading,
  plans,
  errorFreeAnalysis,
  discountCode,
  setDiscountCode,
  selectedPlan,
}: {
  submitTestHandler: any;
  loading: boolean;
  plans: any;
  errorFreeAnalysis: any;
  discountCode: any;
  setDiscountCode: any;
  selectedPlan: any;
}) => {
  const [plansData, setPlansData] = useState<any>(plans);
  const [loadingCheckDisscount, setLoadingCheckDisscount] =
    useState<boolean>(false);
  const [discountCodeError, setDiscountCodeError] = useState<any>("");

  const updatePlansHandler = (_id: number, response: any, isValid: boolean) => {
    if (isValid) {
      const updatedPlans = plans.map((plan: any) =>
        plan.id === _id
          ? { ...plan, new_price: response.data.new_amount }
          : plan
      );

      setPlansData(updatedPlans);
    } else {
      const updatedPlans = plans.map((plan: any) =>
        plan.id === _id ? { ...plan, new_price: null } : plan
      );

      setPlansData(updatedPlans);
    }
  };

  const checkDiscountHandler = async (_id: number, _code: string) => {
    if (!_code.trim()) {
      setDiscountCodeError("لطفاً کد تخفیف را وارد کنید");
      toast.error("لطفاً کد تخفیف را وارد کنید");
      return;
    }

    setLoadingCheckDisscount(true);
    setDiscountCodeError("");

    try {
      const response = await checkDisscount(_id, _code);

      if (!response.data?.discont_code_is_valid) {
        toast.error("کد تخفیف معتبر نیست");
        setDiscountCodeError("کد تخفیف معتبر نیست");
        updatePlansHandler(_id, response, false);
      } else {
        toast.success("کد تخفیف اعمال شد");
        updatePlansHandler(_id, response, true);
      }
    } catch (error) {
      toast.error("خطایی رخ داده است، دوباره تلاش کنید");
    } finally {
      setLoadingCheckDisscount(false);
    }
  };

  return (
    <div className="w-full flex items-start justify-start mb-10 mt-16">
      <Fade triggerOnce className="w-full">
        <div>
          <div>
            <div className="mb-10">
              <h6 className="text-xl lg:text-3xl font-[900] font-rokh text-center">
                نوع تحلیل رو انتخاب کن.{" "}
              </h6>
              <p className="text-center">
                ما انواع مختلفی از تحلیل آزمایش رو انجام می‌دیم، کدوم برات
                مناسب‌تره؟
              </p>
            </div>

            <div className="w-full flex flex-col lg:flex-row items-center mt-2 gap-5">
              {plansData.map((plan: any) => (
                <div
                  key={plan.id}
                  className={`relative flex-1 w-full border rounded-xl p-8 border-2 duration-300 ${
                    plan.id === 3
                      ? "opacity-[0.5]"
                      : "opacity-1 hover:border-pr_purple_dark"
                  }`}
                >
                  {plan.id === 2 && (
                    <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-pr_purple_dark text-white px-8 rounded text-sm font-rokh font-[700] pb-[2px] pt-[7px]">
                      بیشترین تقاضا
                    </div>
                  )}
                  <div className="mb-5 border-b pb-1 flex items-center justify-between">
                    <h3 className="font-rokh font-[700] text-lg lg:text-xl">
                      {plan.title}
                    </h3>

                    <div className="flex items-center gap-1">
                      <h6
                        className={`font-rokh  ${
                          (plan?.new_price || plan?.new_price === 0.0) &&
                          plan.id !== 1
                            ? "line-through font-[700]"
                            : "font-[900]"
                        }`}
                      >
                        {plan.price === 0
                          ? "رایگان"
                          : plan.price.toLocaleString()}
                      </h6>

                      {(plan?.new_price || plan?.new_price === 0.0) && (
                        <h5 className="font-rokh font-[900]">
                          {plan.new_price === 0.0
                            ? "رایگان"
                            : plan.new_price.toLocaleString()}
                        </h5>
                      )}

                      {plan.id !== 1 && plan?.new_price !== 0.0 && (
                        <span className="font-rokh font-[500] text-sm">
                          تومان
                        </span>
                      )}
                    </div>
                  </div>
                  <ul>
                    {Object.entries(plan.meta)
                      ?.sort((a, b) => Number(b[1]) - Number(a[1]))
                      ?.map(([title, isActive]) => (
                        <li
                          key={title}
                          className="flex items-center justify-between mb-[10px]"
                        >
                          <span className="text-sm ml-3">{title}</span>
                          {isActive ? (
                            <BiCheck className="text-pr_green_dark" size={20} />
                          ) : (
                            <IoClose className="text-pr_red_dark" size={20} />
                          )}
                        </li>
                      ))}
                  </ul>

                  <div className="mt-10 lg:min-h-[110px] flex flex-col justify-end">
                    {plan.id === 2 && (
                      <div className="flex items-center justify-between">
                        <h6 className="text-sm">کد تخفیف:</h6>
                        <div className="flex flex-col items-center">
                          <div className="flex tems-center">
                            <div className="border rounded-lg overflow-hidden">
                              <input
                                value={discountCode}
                                onChange={(e) =>
                                  setDiscountCode(e.target.value)
                                }
                                type="text"
                                placeholder="کد تخفیف"
                                className="input input-sm max-w-[150px]"
                              />
                            </div>
                            <button
                              disabled={loadingCheckDisscount}
                              className="btn btn-sm mr-1 bg-pr_primary text-white hover:bg-pr_blue_dark"
                              onClick={() =>
                                checkDiscountHandler(plan.id, discountCode)
                              }
                            >
                              {loadingCheckDisscount ? "..." : "اعمال"}
                            </button>
                          </div>
                          {discountCodeError && (
                            <span className="w-full text-xs text-right text-pr_red_dark mt-1">
                              {discountCodeError}
                            </span>
                          )}
                        </div>
                      </div>
                    )}
                    {plan.id === 1 && errorFreeAnalysis?.detail && (
                      <span className="text-center text-xs text-gray-500 -mb-2">
                        {errorFreeAnalysis?.detail}
                      </span>
                    )}
                    <button
                      disabled={
                        (plan.id === 1 && errorFreeAnalysis?.detail) ||
                        loading ||
                        plan.id === 3
                      }
                      onClick={() => submitTestHandler(plan)}
                      className={`w-full btn ${
                        loading
                          ? "bg-gray-200 text-gray-800"
                          : "bg-pr_primary text-white"
                      }  mt-5 hover:bg-pr_blue_dark`}
                    >
                      {plan.id === 1
                        ? "انتخاب"
                        : loading && selectedPlan === 2
                        ? "در حال انتقال به درگاه پرداخت"
                        : "پرداخت"}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
};

export default AnalyseType;
